export default __webpack_public_path__ + "1e6cb0ea44baf0e547b10bece13d7ba5.png";